/**
 * <pre>
 * UgcWall enums.
 *
 * Summary of responsibilities:
 *
 *  - enumerate any commonly used values
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:UgcWall
 * @namespace
 *
 * @type {Object}
 */
const Enums = {
  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Modules */

  SOCIAL_CONTENT_WALL:     'socialContentWall',
  COLLAGE:                 'collage',
  SOCIAL_CONTENT_CAROUSEL: 'socialContentCarousel',

  /* Campaign. */

  // Social campaign.
  CAMPAIGN_TYPE_SOCIAL:  'type.campaignobject.social',
  CAMPAIGN_TYPE_CONTEST: 'type.campaignobject.contest',

  // Limit of collection content held in state when auto-polling
  CONTENT_CAP: 300,

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Strategies. */

  // Voting
  STRATEGY_VOTING_NONE: 'strategy.voting.none',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Show more mode. */

  // Show more mode (disabled).
  SHOW_MORE_MODE_NONE:    'mode.showmore.none',
  // Show more mode (append to existing items).
  SHOW_MORE_MODE_APPEND:  'mode.showmore.append',
  // Show more mode (prepend to existing items).
  SHOW_MORE_MODE_PREPEND: 'mode.showmore.prepend',
  // Show more mode (replace existing items).
  SHOW_MORE_MODE_REPLACE: 'mode.showmore.replace',
  SHOW_MORE_MODE_AUTO:    'mode.showmore.auto',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Filtering. */

  // Display filter as a select field.
  FILTER_DISPLAY_MODE_SELECT:    'mode.filter.select',
  // Display filter as a button.
  FILTER_DISPLAY_MODE_BUTTON:    'mode.filter.button',
  // Display filter as a text input field.
  FILTER_DISPLAY_MODE_TEXTINPUT: 'mode.filter.textinput',
  // Display filter as date picker.
  FILTER_DISPLAY_MODE_DATE:      'mode.filter.datepicker',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Sorting. */

  // Display sort element as a select field.
  SORT_DISPLAY_MODE_SELECT: 'mode.sort.select',
  // Display sorting element as a button.
  SORT_DISPLAY_MODE_BUTTON: 'mode.sort.buttons',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Item. */

  // Display clicked item in overlay.
  ITEM_SHOW_MODE_OVERLAY:  'overlay',
  // Display clicked items external link.
  ITEM_SHOW_MODE_EXTERNAL: 'external',

  ITEM_TEMPLATES: {
    CONTENT_CARD: 'contentcard',
    MEDIACARD:    'mediacard',
    MEDIALAYER:   'medialayer',
  },
};

export default Enums;
